/*
 * @Author: mazhigang
 * @Date: 2023-04-23 10:45:21
 * @LastEditors: xjf
 * @LastEditTime: 2024-12-31 07:57:55
 */
import Vue from "vue";
import axios from "axios";
import router from "../router";
import { Message } from "element-ui";

Vue.prototype.$version = "1.1.0";
/*第一层if判断生产环境和开发环境*/
console.log(process.env.NODE_ENV);
console.log("1.0.1");
if (process.env.NODE_ENV === "production") {
  console.log(process.env.VUE_APP_FLAG);
  Vue.prototype.$baseUrl = "http://" + window.location.hostname + "/";
  Vue.prototype.environment = "";
} else {
  //dev 开发环境
  Vue.prototype.$baseUrl = "http://manager-uat.baoanlailou.com/";
  // Vue.prototype.$baseUrl = "http://192.168.6.251:9096";
  // Vue.prototype.$baseUrl = "http://192.168.6.9:9096"; //飞哥
  Vue.prototype.environment = "/dev-api";
}
const instance = axios.create({
  baseURL: Vue.prototype.environment,
  requestUrl: Vue.prototype.$baseUrl,
  withCredentials: false,
  responseType: "",
});

instance.interceptors.request.use(
  (config) => {
    config.headers["x-ba-admin-token"] = localStorage.getItem("TOKEN");
    config.headers.Version = Vue.prototype.$version;
    config.headers["Content-Type"] = "application/json; charset=utf-8";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function (response) {
    let webVersion = response.headers["admin_web_version"];
    let version = localStorage.getItem("appVersion");
    if (!version) {
      localStorage.setItem("appVersion", webVersion);
    } else if (webVersion !== version) {
      console.log("版本更新了");
      // window.location.reload();
    }
    // 更新本地版本号
    localStorage.setItem("appVersion", webVersion);
    // 处理响应数据
    if (parseInt(response.data.respCode) !== 0) {
      if (parseInt(response.data.respCode)) {
        if (parseInt(response.data.respCode) == 401) {
          router.push("/login");
          return;
        }
        Message({
          message: response.data.respMsg || "Error",
          type: "error",
          duration: 3 * 1000,
        });
      } else {
        return response;
        // return Promise.reject(new Error(response.data.respMsg || "请求失败"));
      }
      // return Promise.reject(response);
      return Promise.reject(new Error(response.data.respMsg || "请求失败"));
    } else {
      return response.data;
    }
  },
  function (error) {
    // 处理响应失败
    return Promise.reject(error);
  }
);

Vue.prototype.$axios = instance;
export default instance;
